import CreateRequestDispatcher from "../RequestDispatcher";

export default {
    init: (id, feedbackContainerHtml) => {
        const select = $('#' + id);
        select.selectpicker();
        select.parent().append(feedbackContainerHtml);
        select.attr('aria-hidden', 'true');

        const bootstrapSelect = select.parent('.bootstrap-select');
        const button = bootstrapSelect.find('button.dropdown-toggle');

        function updateAriaLabel() {
            const selectedValues = select.val();
            const selectedCount = Array.isArray(selectedValues) ? selectedValues.length : (selectedValues ? 1 : 0);
            const visibleText = bootstrapSelect.find('.filter-option-inner-inner').text();
            let ariaLabel = visibleText;

            if (select.prop('multiple') && selectedCount > 0) {
                const itemText = selectedCount === 1 ? 'item selecionado ' : 'itens selecionados ';
                ariaLabel = `${selectedCount} ${itemText}: ${visibleText}`;
            }

            button.attr('aria-label', ariaLabel);
        }

        if (select.data('actions-box') === true) {

            select.on('shown.bs.select', function () {
                const actionsBoxButtons = bootstrapSelect.find('.bs-actionsbox button');
                const options = bootstrapSelect.find('.dropdown-item');
                if (actionsBoxButtons.length) {
                    actionsBoxButtons.attr('tabindex', 0);
                    options.attr('tabindex', -1);
                    options.attr('role', 'presentation');
                }
            });
        }

        select.on('changed.bs.select', updateAriaLabel);
        updateAriaLabel();

        if (select.data('live-search') !== true) {
            const announcerId = id + '-sr-announcer';
            const announcer = $(`<div id="${announcerId}" class="sr-only" role="status" aria-live="polite"></div>`);
            bootstrapSelect.append(announcer);
            let keydownTimeout;

            select.on('shown.bs.select', function () {
                const optionsCount = bootstrapSelect.find('.dropdown-menu li').length;
                const optionsAvailableText = optionsCount === 1 ? 'item' : 'itens';

                let announcement = `Lista com ${optionsCount} ${optionsAvailableText} `;

                if (select.data('actions-box') === true) {
                    announcement += ' (Usar tab para acessar botões de ações)';
                }
                announcer.text(announcement);
            });

            bootstrapSelect.on('keydown', function (e) {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Tab') {

                    clearTimeout(keydownTimeout);
                    keydownTimeout = setTimeout(() => {
                        const activeLi = bootstrapSelect.find('.dropdown-menu li.active');
                        if (activeLi.length) {
                            const optionText = activeLi.find('a').text();
                            const isSelected = activeLi.hasClass('selected');
                            const announcement = isSelected ? `${optionText} (marcado)` : `${optionText} (não marcado)`;
                            announcer.text(announcement);
                        }
                    }, 50);
                }
            });

            select.on('changed.bs.select', function (e, clickedIndex, isSelected) {
                if (typeof clickedIndex !== 'undefined') {
                    const changedOptionText = select.find('option').eq(clickedIndex).text();
                    if (isSelected) {
                        announcer.text(`${changedOptionText} adicionado`);
                    } else {
                        announcer.text(`${changedOptionText} desmarcado`);
                    }
                }
            });

            select.on('hidden.bs.select', function () {
                announcer.text('');
            });
        }
    },

    /**
     *
     * @param dependencyName string
     * @param inputId string
     * @param spinnerPlaceholder string
     * @param childId string
     * @param dataSource object {url, method, paramsFn}
     * @param {string|null} placeholder
     * @param placeholderIfNull
     * @param shouldTriggerSelectOnChange
     */
    addDependency: (
        dependencyName,
        inputId,
        spinnerPlaceholder,
        childId,
        dataSource,
        placeholder,
        placeholderIfNull,
        shouldTriggerSelectOnChange
    ) => {
        const jqInput = $('#' + inputId)
        const requestDispatcher = CreateRequestDispatcher()

        //todo formatar o resultado (nao posso garantir que vai ser sempre innerHTML, value e data

        //todo quem gera isso é o pai né... assim vai ter duplicatas no caso de mais de um elemento dependente
        function getSelectedOptionData(el) {
            var selectedOption = el.selectedOptions[0];

            return {
                innerHTML: selectedOption.innerHTML,
                value: selectedOption.value,
                data: selectedOption.dataset
            };
        }


        function setChildSelectDisabled(placeholder, child) {
            child.disabled = true;
            addOptionsToSelect(placeholder, child, []);
        }


        /**
         *
         * @param placeholder string|null
         * @param select
         * @param setOptions
         * @param dataAttributesMap
         * @param valueFormatFn function
         * @param labelFormatFn function
         */
        function addOptionsToSelect(
            placeholder,
            select,
            setOptions,
            dataAttributesMap,
            valueFormatFn,
            labelFormatFn
        ) {
            let optionsHTML = ''

            if (placeholder !== null) {
                optionsHTML = `<option value=''>${placeholder}</option>`;
            }

            setOptions.forEach(function (v, k) {
                const value = valueFormatFn(k, v)
                const innerHTML = labelFormatFn(k, v)
                const optionAttrsString = Object.getOwnPropertyNames(dataAttributesMap)
                    .map((returnAttr, optionAttr) => `${optionAttr}="${o[returnAttr]}"`)
                    .join(' ')

                optionsHTML += `<option value="${value}" ${optionAttrsString}>${innerHTML}</option>`
            });

            select.innerHTML = optionsHTML
            $("#" + select.id).selectpicker('refresh')
        }

        function clearSelect(el) {
            el.disabled = true;
            el.innerHTML = '';

            const jqEl = $("#" + el.id)
            jqEl.selectpicker('refresh');
            jqEl.trigger('change')
        }

        const showSpinner = (spinner) => {
            spinner.style = ''
        }
        const hideSpinner = (spinner) => {
            spinner.style = 'display:none;'
        }

        function clearFeedbackMessage(feedbackMessage) {
            feedbackMessage.html('');
            feedbackMessage.hide();
        }

        function setFeedbackMessage(feedbackMessage, message) {
            feedbackMessage.html(message);
            feedbackMessage.show();
        }

        jqInput.change(function () {
            requestDispatcher.abort()
            const select = this;
            const childEl = document.getElementById(childId);
            const feedbackMessage = $('#' + childEl.id + '-feedbackMessage')

            clearSelect(childEl);
            clearFeedbackMessage(feedbackMessage);

            const spinner = document.getElementById(spinnerPlaceholder)

            if (select.value) {
                showSpinner(spinner)
                const valueFormatFn = dataSource.valueFormatFn || UI.defaults.defaultValueFormatFn;
                const labelFormatFn = dataSource.labelFormatFn || UI.defaults.defaultLabelFormatFn
                const dataAttributesMap = dataSource.dataAttributesMap
                const onSuccess = function (data) {
                    hideSpinner(spinner);

                    childEl.disabled = false;

                    addOptionsToSelect(
                        placeholder,
                        childEl,
                        data,
                        dataAttributesMap,
                        valueFormatFn,
                        labelFormatFn
                    );

                    if (placeholder === null) {
                        $(childEl).trigger('change');
                    }
                }
                const onError = (error) => {
                    if (error.name === 'AbortError') {

                    } else {
                        hideSpinner(spinner);
                        setFeedbackMessage(feedbackMessage, error);
                        console.error(error);
                    }
                }

                const promise = requestDispatcher.dispatch({
                    dataSource: dataSource,
                    componentParams: {},
                    userCallbacks: onSuccess,
                    userCatch: onError,
                })

            } else {
                hideSpinner(spinner);
                setChildSelectDisabled(placeholderIfNull, childEl);
            }
        })

        if (shouldTriggerSelectOnChange) {
            jqInput.change();
        }
    },
}
